import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CsiHttp } from '../../core/csi-http';

@Injectable()
export class FuncoesClienteService {

  constructor(private http: CsiHttp) { }

  api = environment.principalAPI;

  consultaControleAcessoFuncionalidade(cdFuncao, modulo) {
    const url = this.api + '/consultaControleAcessoFuncionalidade';
    return this.http.postIgnore(url, {cdFuncao: cdFuncao, modulo: modulo}).map(
      resposta => {
        return resposta;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/funcoes-cliente.service.ts